import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ThemeManager() {
  const { pathname } = useLocation();
  const isDark = !pathname.startsWith('/admin') && pathname !== '/login';

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  return null;
}
